import OneBarChartComponent from "./one-bar-chart/one-bar-chart.component";
import TwoBarChartComponent from "./two-bar-chart/two-bar-chart.component";

const ChartsModule = angular
    .module("app.charts", [])
    .component("oneBarChart", OneBarChartComponent)
    .component("twoBarChart", TwoBarChartComponent);


export default ChartsModule;


// WEBPACK FOOTER //
// ./sources/components/charts/charts.module.js